import { Pagination } from 'react-bootstrap';

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
  nextPage: number | null;
  prevPage: number | null;
}

const PaginationControls = ({ currentPage, totalPages, onPageChange, nextPage, prevPage }: PaginationControlsProps) => {
  if (totalPages < 1) return null;

  return (
    <Pagination className="justify-content-center">
      <Pagination.Prev disabled={!prevPage} onClick={() => onPageChange(currentPage - 1)} />
      <Pagination.Item className={currentPage > 0 ? 'active' : ''}>{currentPage}</Pagination.Item>
      <Pagination.Next disabled={!nextPage} onClick={() => onPageChange(currentPage + 1)} />
    </Pagination>
  );
};

export default PaginationControls;
